import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const addItem = (item) => {
    setItems(prev => {
      const existingIndex = prev.findIndex(
        i => i.photo_id === item.photo_id && 
             i.product_id === item.product_id && 
             i.package_id === item.package_id &&
             i.background_id === item.background_id &&
             JSON.stringify(i.customizations) === JSON.stringify(item.customizations)
      );
      
      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex].quantity += item.quantity || 1;
        return updated;
      }
      
      return [...prev, { ...item, id: Date.now().toString() }];
    });
  };

  const removeItem = (itemId) => {
    setItems(prev => prev.filter(item => item.id !== itemId));
  };

  const updateQuantity = (itemId, quantity) => {
    if (quantity <= 0) {
      removeItem(itemId);
      return;
    }
    setItems(prev => prev.map(item => 
      item.id === itemId ? { ...item, quantity } : item
    ));
  };

  const clearCart = () => {
    setItems([]);
  };

  const getTotal = () => {
    return items.reduce((sum, item) => {
      const price = item.package?.price || item.product?.price || 0;
      return sum + (price * (item.quantity || 1));
    }, 0);
  };

  const getTax = () => {
    return getTotal() * 0.13; // 13% HST
  };

  const getGrandTotal = () => {
    return getTotal() + getTax();
  };

  return (
    <CartContext.Provider value={{
      items,
      isOpen,
      setIsOpen,
      addItem,
      removeItem,
      updateQuantity,
      clearCart,
      getTotal,
      getTax,
      getGrandTotal,
      itemCount: items.reduce((sum, item) => sum + (item.quantity || 1), 0)
    }}>
      {children}
    </CartContext.Provider>
  );
};
